import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TargetAudience } from '../components/TargetAudience';
import { ServicesGrid } from '../components/ServicesGrid';
import { ProcessSteps } from '../components/ProcessSteps';
import { TrustSignals } from '../components/TrustSignals';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="w-full min-h-screen" data-id="element-98">
      <Header data-id="element-99" />
      <Hero data-id="element-100" />
      <TargetAudience data-id="element-101" />
      <ServicesGrid data-id="element-102" />
      <ProcessSteps data-id="element-103" />
      <TrustSignals data-id="element-104" />
      <Footer data-id="element-105" />
    </div>;
}